// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () => import("apps/transporter/TransporterEntry"),
  orderPrio: 40,
  iconType: "schedule",
  name: "transporter",
  subApps: [
    {
      name: "create",
      requirePermission: ["transporter:write", "transporter:edit-users"]
    },
    {
      name: "search",
      requirePermission: "fleet:view"
    },
    {
      name: "applications",
      requirePermission: "transporter:applications"
    },
    {
      name: "permits",
      requirePermission: "transporter:view"
    }
  ]
}: AppType)
